<template>
  <div>
    <Field label="圈子名称：" placeholder="输入圈子名称" :attr="{ maxlength: 8 }" v-model="circlename"></Field>
    <Field label="圈子简介：" placeholder="圈子简介（80个汉字以内）" :attr="{ maxlength: 80 }" type="textarea" rows="4"
           v-model="introduction"></Field>
    <Button size="large" type="primary" @click="Create">创建圈子</Button>
  </div>
</template>

<script>
import {Field, Button} from 'mint-ui';

export default {
  name: "CreateCircle",
  components: {Field, Button},
  data() {
    return {
      circlename: '',
      introduction: '',
      yhnm: localStorage.getItem('yhnm'),
      token: localStorage.getItem('token'),
      createCircleUrl: '/api/circle/createCircle',
    }
  },
  methods: {
    Create() {
      let that = this
      that.$ajax({
        method: 'get',
        url: that.createCircleUrl,
        params: {circlename: that.circlename, introduction: that.introduction, yhnm: that.yhnm},
        headers: {token: that.token}
      }).then((response) => {
        if (!response.data.result) {
          that.$messagebox.alert(response.data.message)
        }
        that.$router.go(-1)
      }).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
  },
}
</script>

<style scoped>

</style>
